import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { reset } from 'redux-form';
import List from './List';
import Filter from './Filter';
import { loadSelfAssessments } from './actions';
import { initialize } from 'redux-form';
import { Panel } from 'react-bootstrap';

class SelfAssessments extends Component {

	constructor(props) {
		super(props);
		this.handleFilterSubmit = this.handleFilterSubmit.bind(this);
		this.handleFilterReset = this.handleFilterReset.bind(this);
		this.handleListEvent = this.handleListEvent.bind(this);
	}

	componentDidMount() {
		const { filter, sortKey, sortDirection, pageNumber, pageSize } = this.props.pagination;
		this.loadData({ filter, sortKey, sortDirection, pageNumber, pageSize });
	}

	handleFilterSubmit(filter) {
		const { sortKey, sortDirection, pageSize } = this.props.pagination;
		this.loadData({ filter, sortKey, sortDirection, pageNumber: 1, pageSize });
	}

	handleFilterReset() {
		this.props.resetFilter();
		this.handleFilterSubmit({});
	}

	handleListEvent(listPagination) {
		const { filter } = this.props.pagination;
		this.loadData({ filter, ...listPagination });
	}

	loadData({ filter, sortKey, sortDirection, pageNumber, pageSize }) {
		const { loadSelfAssessments } = this.props;
		loadSelfAssessments({ ...filter, sortKey, sortDirection, pageSize, pageNumber });
	}

	render() {
		const { data, formStatusTypes } = this.props;

		return (
			<div>
				<Filter
					formStatusTypes={formStatusTypes}
					onSubmit={this.handleFilterSubmit}
					onReset={this.handleFilterReset}
					loading={this.props.pagination.loading}
				/>
				<Panel>
					<Panel.Body>
						<List
							data={data}
							onFetchData={this.handleListEvent}
							{...this.props.pagination}
						/>
					</Panel.Body>
				</Panel>
			</div>
		);
	}
}

const mapStateToProps = (state) => {

	const {
		pagination,
		entities: { selfAssessments },
		lookups: { formStatusTypes },
	} = state;

	const selfAssessmentsPagination = pagination.selfAssessments.all || { ids: [], pageNumber: 1, pageSize: 10 };

	return {
		data: selfAssessmentsPagination.ids.map(id => selfAssessments[id]),
		pagination: selfAssessmentsPagination,
		formStatusTypes
	};
};

const mapDispatchToProps = {
	loadSelfAssessments,
	resetFilter: () => reset('selfAssessmentsFilter'),
	initializeFilter: (data, fields) => initialize('selfAssessmentsFilter', data, fields)
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(SelfAssessments));